// @ts-nocheck
import constants from "@store/constants";
import { HeaderStickyLevels, useHeaderContext } from "@store/Framework/Components/Header/HeaderContext/HeaderContext";
import useHeader from "@store/Framework/Components/Header/useHeader";
import { useScrollContext } from "@store/Framework/Components/ScrollContext/ScrollContext";
import { useEffect } from "react";

export default () => {
    const { setHeaderLevel, headerLevel } = useHeaderContext();
    const { headerHeightGap } = useHeader();
    const { scroll } = useScrollContext();

    const headerShouldBeNormal =
        scroll < constants.secondaryHeaderHeight[0] && headerLevel !== HeaderStickyLevels.normal;

    const headerShouldBeSticky =
        scroll === constants.secondaryHeaderHeight[0] && headerLevel !== HeaderStickyLevels.sticky;

    const headerShouldBeStickyingSmall =
        scroll > constants.secondaryHeaderHeight[0] &&
        scroll < constants.secondaryHeaderHeight[0] + headerHeightGap &&
        headerLevel !== HeaderStickyLevels.stickyingSmall;

    const headerShouldBeStickySmall =
        scroll > constants.secondaryHeaderHeight[0] + headerHeightGap && headerLevel !== HeaderStickyLevels.stickySmall;

    useEffect(() => {
        if (headerShouldBeNormal) {
            setHeaderLevel(HeaderStickyLevels.normal);
        }

        if (headerShouldBeSticky) {
            setHeaderLevel(HeaderStickyLevels.sticky);
        }

        if (headerShouldBeStickyingSmall) {
            setHeaderLevel(HeaderStickyLevels.stickyingSmall);
        }

        if (headerShouldBeStickySmall) {
            setHeaderLevel(HeaderStickyLevels.stickySmall);
        }
    }, [scroll]);
};
